import React from 'react';
import { AwardIcon } from 'lucide-react';
import { awards, references, profile } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
export function Recognition() {
  const [featured, ...rest] = awards;
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-221" data-mp="htl660zj4gon">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-222" data-mp="mso7bace22rc">
        <PageHeader overline="Recognition & References" title="Award highlights and executive references" description="External validation of the ethics, culture, and wellbeing programs built under her stewardship — alongside references available to nominating committees." data-id="element-223" data-mp="mq1zraphzn94" />

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-224" data-mp="3ta9ghbjg7vk">
          <article className="bg-emerald p-9 lg:col-span-5 lg:p-10" data-id="element-225" data-mp="3ulfyowdbtqd">
            <AwardIcon className="h-8 w-8 text-emerald-200" aria-hidden="true" data-id="element-226" data-mp="32i96u0nx6zve" />
            <p className="mt-7 font-sans text-[11px] font-semibold uppercase tracking-overline text-emerald-200" data-id="element-227" data-mp="37hu6yeette9p">
              {featured.issuer} · {featured.years}
            </p>
            <h2 className="mt-4 font-display text-3xl leading-tight text-white" data-id="element-228" data-mp="175uc3397qbjf">{featured.name}</h2>
            <p className="mt-6 font-sans text-[15px] leading-relaxed text-white/80" data-id="element-229" data-mp="12em2o77vuq69">
              Recognized in consecutive years for ethical business practice and the treatment of the
              workforce — the recognition she points to most often in board conversation.
            </p>
          </article>

          <div className="lg:col-span-7" data-id="element-230" data-mp="oejmcpf844t4">
            <h2 className="font-display text-2xl text-navy" data-id="element-231" data-mp="odi2pwk569zs">Further recognition</h2>
            <ul className="mt-7 space-y-6" data-id="element-232" data-mp="jgrkb2kv72b7">
              {rest.map(award => <li key={award.name} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1" data-id="element-233" data-mp="ff69dmrw4y3n">
                  <div data-id="element-234" data-mp="2dspvha2qi89q">
                    <p className="font-sans text-[17px] font-medium leading-snug text-navy" data-id="element-235" data-mp="2dt7wsl497coi">
                      {award.name}
                    </p>
                    <p className="mt-1 font-sans text-sm text-navy-400" data-id="element-236" data-mp="75igfwf252wy">{award.issuer}</p>
                  </div>
                  <span className="shrink-0 font-sans text-xs uppercase tracking-overline text-emerald" data-id="element-237" data-mp="bxilg39zim0e">
                    {award.years}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-20" data-id="element-238" data-mp="24b91ygtu5qt">
          <h2 className="font-display text-3xl text-navy" data-id="element-239" data-mp="pvqh87vabh9z">References</h2>
          <div className="mt-8 grid gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-240" data-mp="puf8dtmzfjc0">
            {references.map(reference => <article key={reference.name} className="flex flex-col bg-parchment-light p-8" data-id="element-241" data-mp="gvtuwcwdaui3">
                <h3 className="font-display text-xl text-navy" data-id="element-242" data-mp="lueldklthztc">{reference.name}</h3>
                <p className="mt-3 font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-243" data-mp="lwhnh308vjef">
                  {reference.affiliation}
                </p>
                <p className="mt-auto pt-6 font-sans text-sm text-emerald" data-id="element-244" data-mp="36lxb5p462rzu">
                  {reference.relationship}
                </p>
              </article>)}
          </div>
          <p className="mt-8 font-sans text-sm text-navy-400" data-id="element-245" data-mp="2u18d7tu9y4nn">{profile.contactNote}</p>
        </div>
      </div>
    </section>;
}